/*
 * @Author: 赵泽文
 * @Date: 2022-03-07 16:36:38
 * @LastEditors: 茆闯
 * @LastEditTime: 2023-10-13 14:27:13
 * @Description: 调出单数据存储
 */

import type {
  IEarthTransferOutOrderModel,
  IEarthTransferOutOrderStore,
} from '@monorepo/types/earthOrders/transferOutOrder/transferOutOrder.types';

import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';
// import moment from 'moment';

const initState: IEarthTransferOutOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_from: '',
    date_to: '',
    date: getToday(),
    date_type: '制单时间',
  },
  auditNo: '',
  // auditProductList: [],
};

const earthTransferOutOrderStore: IEarthTransferOutOrderModel = {
  namespace: 'earthTransferOutOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default earthTransferOutOrderStore;
